export default __webpack_public_path__ + "dddad2c7c0d251e2830bc4fe417d25aa.png";